import { FC } from "react";
import SpaceBetweenCenter from "shared/components/Layout/components/SpaceBetweenCenter";
import {
  Wrapper,
  RedCard,
  TitleSkeleton,
  PurpleCard,
  DescriptionSkeleton,
  OrangeCard,
} from "../../../styled";

const HorizontalCarouselColoredPromotions: FC = () => {
  return (
    <Wrapper>
      <SpaceBetweenCenter gap={2}>
        <RedCard>
          <TitleSkeleton />
          <DescriptionSkeleton />
        </RedCard>
        <OrangeCard>
          <TitleSkeleton />
          <DescriptionSkeleton />
        </OrangeCard>
        <PurpleCard>
          <TitleSkeleton />
          <DescriptionSkeleton />
        </PurpleCard>
        <RedCard>
          <TitleSkeleton />
          <DescriptionSkeleton />
        </RedCard>
        <OrangeCard>
          <TitleSkeleton />
          <DescriptionSkeleton />
        </OrangeCard>
      </SpaceBetweenCenter>
    </Wrapper>
  );
};

export default HorizontalCarouselColoredPromotions;
